module.exports = __webpack_public_path__ + "img/traffic-thumb.92631265.png";